import { render, staticRenderFns } from "./MonitorHeader.vue?vue&type=template&id=04b7dcbc&scoped=true&"
import script from "./MonitorHeader.vue?vue&type=script&lang=js&"
export * from "./MonitorHeader.vue?vue&type=script&lang=js&"
import style0 from "./MonitorHeader.vue?vue&type=style&index=0&id=04b7dcbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b7dcbc",
  null
  
)

export default component.exports